import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Header.css';
import logo from '../images/logo.png'; //logo

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <nav className="navbar">
      <div className="logo">
        <Link to="/">
          <img src={logo} alt="MyLogo" />
        </Link>
      </div>

      <div className="hamburger" onClick={toggleMenu}>
        <span className="bar" />
        <span className="bar" />
        <span className="bar" />
      </div>

      <ul className={`nav-links ${menuOpen ? 'active' : ''}`}>
        <li><Link to="/" onClick={() => setMenuOpen(false)}>Home</Link></li>
        <li><Link to="/events" onClick={() => setMenuOpen(false)}>Events</Link></li>
        <li><Link to="/intramurals" onClick={() => setMenuOpen(false)}>Intramurals</Link></li>
        <li><Link to="/luau" onClick={() => setMenuOpen(false)}>Lū'au</Link></li>
        <li><Link to="/officers" onClick={() => setMenuOpen(false)}>Officers</Link></li>
        <li><Link to="/faq" onClick={() => setMenuOpen(false)}>FAQ</Link></li>
        <li><Link to="/advice" onClick={() => setMenuOpen(false)}>Advice</Link></li>
      </ul>
    </nav>
  );
}

export default Header;
